import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import reducer from "./reducers";

const middleware = [thunk];

if (process.env.NODE_ENV === "development") {
  const logger = require("redux-logger").default;
  middleware.push(logger);
}

const composeEnhancers = composeWithDevTools({});

const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
